import { accountLogout } from '@ks/open-login-iframe-client';
import { portalAccountLogout } from '@/apis/login';
import { portalSid, getEnvType } from '@/common/consts';
import { ID_ORIGIN } from '@api/origins';

export function logout() {
    const indexUrl = `https://${location.host}`;
    portalAccountLogout();
    accountLogout(getEnvType(), portalSid);
    const idLogoutUrl = new URL(`${ID_ORIGIN}rest/infra/n/logout`);
    idLogoutUrl.searchParams.set('sid', portalSid);
    idLogoutUrl.searchParams.set('followUrl', indexUrl);

    const redirectUrl = new URL(
        `https://${location.host}/portal/rest/infra/logout`,
    );
    redirectUrl.searchParams.set('sid', portalSid);
    redirectUrl.searchParams.set('followUrl', idLogoutUrl.toString());
    window.location.href = redirectUrl.toString();
}
